import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const GraySpan = styled.span`
  color: ${({ theme }) => theme.palette.themeCommon.gray};
`;
